import type { CSSObject } from '@mui/material/styles';
import { createFocusRingStyles, createMotionTransition } from '../interaction';
import { designTokens } from '../tokens';

/** 업무 탭과 목록 필터가 공유하는 표면이며 역할·키보드 동작은 각 컴포넌트가 소유합니다. */
export const tabListStyles: CSSObject = {
  minHeight: designTokens.layout.pillTabHeight,
  gap: `${designTokens.space.xs}px`,
  [designTokens.media.touchTarget]: { minHeight: designTokens.layout.touchTargetMinSize },
};

export const tabItemStyles: CSSObject = {
  minWidth: 0,
  maxWidth: 'none',
  minHeight: designTokens.layout.pillTabHeight,
  flex: '0 0 auto',
  boxSizing: 'border-box',
  paddingInline: `${designTokens.space.md}px`,
  paddingBlock: `${designTokens.space.xs}px`,
  border: '1px solid transparent',
  borderRadius: designTokens.radius.tab,
  backgroundColor: 'transparent',
  color: designTokens.color.secondaryText,
  ...designTokens.typography.ui,
  fontWeight: 500,
  letterSpacing: 'normal',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  transition: createMotionTransition(['background-color', 'border-color', 'color', 'opacity'], 'tab'),
  [designTokens.media.touchTarget]: { minHeight: designTokens.layout.touchTargetMinSize },
  '&:hover': { backgroundColor: designTokens.color.hoverSurface, color: designTokens.color.primaryText },
  '&.Mui-selected, &[aria-pressed="true"]': {
    backgroundColor: designTokens.color.selectedNavigationSurface,
    color: designTokens.color.actionDark,
    borderColor: designTokens.color.brandBorder,
    '&:hover': { backgroundColor: designTokens.color.selectedHoverSurface, color: designTokens.color.actionDark },
    '@media (forced-colors: active)': {
      borderColor: 'Highlight',
      color: 'CanvasText',
      backgroundColor: 'Canvas',
      '&:hover': { color: 'CanvasText', backgroundColor: 'Canvas' },
    },
  },
  '&.Mui-focusVisible, &:focus-visible': createFocusRingStyles({ inset: true }),
  '&.Mui-disabled': {
    opacity: designTokens.button.disabledOpacity,
    color: designTokens.color.secondaryText,
  },
  '&.Mui-selected.Mui-disabled, &[aria-pressed="true"].Mui-disabled': { color: designTokens.color.actionDark },
};

/** 페이지 헤더와 명시적인 capsule 탭이 공유하는 흰 묶음 표면입니다. */
export const capsuleTabTrackStyles: CSSObject = {
  width: 'max-content',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  padding: `${designTokens.space.xxs}px`,
  borderRadius: designTokens.radius.pill,
  backgroundColor: designTokens.color.canvas,
  outline: `1px solid ${designTokens.color.divider}`,
  outlineOffset: -1,
  boxShadow: designTokens.shadow.surface,
  gap: designTokens.space.none,
  '@media (forced-colors: active)': {
    outline: '1px solid CanvasText',
    outlineOffset: -1,
    backgroundColor: 'Canvas',
    boxShadow: 'none',
  },
};

export const capsuleTabItemStyles: CSSObject = {
  ...tabItemStyles,
  borderRadius: designTokens.radius.pill,
  '&.Mui-selected.Mui-disabled, &[aria-pressed="true"].Mui-disabled': {
    color: designTokens.color.actionDark,
    '@media (forced-colors: active)': { color: 'GrayText' },
  },
};
